import { render, staticRenderFns } from "./GiftRecord2.vue?vue&type=template&id=7eba3b15&scoped=true"
import script from "./GiftRecord2.vue?vue&type=script&lang=js"
export * from "./GiftRecord2.vue?vue&type=script&lang=js"
import style0 from "./GiftRecord2.vue?vue&type=style&index=0&id=7eba3b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eba3b15",
  null
  
)

export default component.exports